/**
 * Карты соответсвия серверных ошибок
 * @module Constants/serverErrors
 * */

/**
 * Елемент карты соответствия
 * @typedef {Object} MatItem
 * @property {String} label - Юзерфрендли сообщение
 * @property {String} value - серверное сообщение о ошибке
 * */

/**
 *  @constant {Array.<MapItem>} - Серверные ошибки
 * */
export const SERVER_ERRORS = []

export const DEFAULT_ERROR = 'Что-то пошло не так'

export default [
  ...SERVER_ERRORS
]
